<!--
 * @Descripttion: 卡片海报
 * @FilePath: /mall-wap-vue/src/views/product/detail/components/Poster/index.vue
 * @Author: 张兴业
 * @Date: 2020-10-28 10:02:39
 * @LastEditors: hl
 * @LastEditTime: 2026-03-26 14:35:30
-->
<template>
  <div class="poster">
    <van-dialog
      v-model="show"
      :width="width"
      :showConfirmButton="showConfirmButton"
      :close-on-click-overlay="true"
      :before-close="closePoster"
    >
      <div class="canvas_back">
        <canvas
          id="card-poster"
          :width="width * 2"
          :height="height * 2"
          class="canvas"
        />
      </div>
      <img v-if="posterImg" :src="posterImg" alt="" class="posterImg" />
      <div class="actions">
        <div class="actions_item">
          <a :href="posterImg" download="赠送海报">
            <img src="@/assets/mine/download.png" alt="" />
          </a>
          <div>
            <span>长按海报保存</span>
          </div>
        </div>
        <div class="actions_item" @click="openShare">
          <img src="@/assets/mine/wechat.png" alt="" />
          <div>
            <span>微信好友</span>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { fillRoundRect, circleImg, fillRoundRectEvery } from "@/utils/canvas";

export default {
  props: {
    show: {
      type: Boolean,
      value: true
    },
    posterItem: {
      type: Object,
      default() {
        return {};
      }
    },
    data: {
      type: Object,
      default() {
        return {
          title: "宇***超赠你2张鲜奶卡",
          desc: "精品好货，别错过哦",
          avatar: require("@/assets/mine/per_photo@2x.png"),
          logo: require("@/assets/mine/az_logo.png"),
          cardPic: require("@/assets/mine/card_cover.png"),
          name: "a2鲜牛奶 电子周卡",
          spe: "规格：电子周卡",
          qrcode: require("@/assets/mine/qrcode.png"),
          plane: require("@/assets/mine/plane.png"),
          planeTitle: "跨境商品",
          global: require("@/assets/mine/global.png"),
          globalTitle: "品牌直采",
          service: require("@/assets/mine/service.png"),
          serviceTitle: "假一赔十",
          shouquan: require("@/assets/mine/shouquan.png"),
          shouquanTitle: "品牌授权"
        };
      }
    }
  },
  data() {
    return {
      showConfirmButton: false,
      posterImg: "",
      posterUrl: ""
    };
  },
  computed: {
    getSimpleUserInfo() {
      return this.$store.getters.getSimpleUserInfo;
    },
    width() {
      return document.documentElement.clientWidth - 48;
    },
    height() {
      // return document.documentElement.clientHeight - 100;
      return this.width - 24 + 79 + 10 + 118 + 24;
    }
  },
  watch: {
    // show() {
    //   this.$nextTick(() => {
    //     this.createPoster();
    //   });
    // }
  },
  created() {
    // console.log(this.getSimpleUserInfo);
    this.$nextTick(() => {
      this.createPoster();
    });
  },
  mounted() {
    const encodeUrl = encodeURIComponent(
      `${this.posterItem.minifurl}${this.posterItem.minisurl}`
    );
    this.posterUrl = `/api/daemon/files/createQrCode?content=${encodeUrl}&height=200&width=200`;
  },
  methods: {
    createPoster() {
      const canvas = document.getElementById("card-poster");
      if (canvas && canvas.getContext) {
        const ctx = canvas.getContext("2d");

        const w = this.width * 2;
        const h = this.height * 2;

        fillRoundRect(ctx, 0, 0, w, h, 8, "#F6F7F8");

        fillRoundRect(ctx, 24, 20, w - 48, 118, 54, "white");

        const avatarImg = new Image();
        avatarImg.setAttribute("crossOrigin", "Anonymous");
        avatarImg.src =
          this.getSimpleUserInfo.avatarUrl + "?t=" + new Date().getTime();
        avatarImg.onload = () => {
          circleImg(ctx, avatarImg, 32, 26, 104, 104, 52);

          ctx.font = "28px bold PingFangSC-Medium, PingFang SC";
          ctx.fillStyle = "#000";
          ctx.textAlign = "left";
          ctx.textBaseline = "top";
          ctx.fillText(
            `${this.getSimpleUserInfo.username.substring(0, 15)}向你推荐`,
            152,
            40
          );

          ctx.font = "24px PingFangSC-Medium, PingFang SC";
          ctx.fillStyle = "#999";
          ctx.textAlign = "left";
          ctx.textBaseline = "top";
          ctx.fillText(this.data.desc, 152, 84);

          // const logoImg = new Image();
          // logoImg.src = this.data.logo;
          // logoImg.setAttribute("crossOrigin", "Anonymous");
          // logoImg.onload = () => {
          //   ctx.drawImage(logoImg, 510, 34, 82.8, 88);

          fillRoundRect(ctx, 24, 158, w - 48, w - 48, 8, "#FFF");

          const cardPicImg = new Image();
          cardPicImg.setAttribute("crossOrigin", "Anonymous");
          cardPicImg.src =
            this.posterItem.spuImg +
            "?x-oss-process=image/resize,h_320,m_lfit&" +
            "t=" +
            new Date().getTime();
          cardPicImg.onload = () => {
            ctx.drawImage(cardPicImg, 24, 158, w - 48, w - 48);

            const h1 = 158 + w - 48 + 20;

            fillRoundRect(ctx, 24, h1, w - 48, 216, 8, "white");

            ctx.font = "32px bold PingFangSC-Semibold, PingFang SC";
            ctx.fillStyle = "#f00";
            ctx.textAlign = "left";
            ctx.textBaseline = "top";
            ctx.fillText(
              `${this.$G("symbol")}${this.posterItem.storePrice}`,
              48,
              h1 + 20
            );

            ctx.font = "28px Semibold PingFangSC-Semibold, PingFang SC";
            ctx.fillStyle = "#999";
            ctx.textAlign = "left";
            ctx.textBaseline = "top";
            ctx.textDecoration = "line-through";
            ctx.fillText(
              `${this.$G("symbol")}${this.posterItem.crossedPrice}`,
              48,
              h1 + 60
            );

            ctx.beginPath();
            ctx.strokeStyle = "#666"; //strokeStyle对应stroke   fillstyle--fill  默认黑色
            ctx.lineWidth = 1; //默认1
            //cxt.moveTo(x,y):起点x y轴的坐标
            ctx.moveTo(48, h1 + 75);
            //cxt.lineTo(x,y):终点x y轴的坐标
            ctx.lineTo(140, h1 + 75);
            ctx.stroke();
            //cxt.fill();
            ctx.closePath();

            ctx.font = "28px blod PingFangSC-Regular, PingFang SC";
            ctx.fillStyle = "#000";
            ctx.fillText(
              `${
                this.posterItem.name
                  ? this.posterItem.name.substring(0, 12) + "..."
                  : ""
              }`,
              48,
              h1 + 120
            );

            ctx.font = "24px PingFangSC-Regular, PingFang SC";
            ctx.fillStyle = "#999";
            ctx.fillText(
              `${
                this.posterItem.resume
                  ? this.posterItem.resume.substring(0, 12) + "..."
                  : ""
              }`,
              48,
              h1 + 160
            );

            const qrcodeImg = new Image();
            qrcodeImg.src = this.posterUrl;
            qrcodeImg.setAttribute("crossOrigin", "Anonymous");
            qrcodeImg.onload = () => {
              ctx.drawImage(qrcodeImg, w - 24 - 200, h1 + 10, 200, 200);

              const h2 = h1 + 216 + 20;

              fillRoundRectEvery(ctx, 0, h2, w, 48, 8, 8, 0, 0, "#BF9264");

              const globalImg = new Image();
              globalImg.src = this.data.global;
              globalImg.setAttribute("crossOrigin", "Anonymous");
              globalImg.onload = () => {
                const h3 = h2 + 8;
                const h4 = h2 + 12;

                ctx.drawImage(globalImg, 16, h3, 28, 28);

                ctx.font = "20px PingFangSC-Regular, PingFang SC";
                ctx.fillStyle = "white";
                ctx.textBaseline = "top";
                ctx.fillText(this.data.globalTitle, 52, h4);

                const w0 = w / 4;

                const planeImg = new Image();
                planeImg.src = this.data.plane;
                planeImg.setAttribute("crossOrigin", "Anonymous");
                planeImg.onload = () => {
                  ctx.drawImage(planeImg, 18 + w0, h3, 28, 28);

                  ctx.font = "20px PingFangSC-Regular, PingFang SC";
                  ctx.fillStyle = "white";
                  ctx.textBaseline = "top";
                  ctx.fillText(this.data.planeTitle, w0 + 18 + 28 + 4, h4);

                  const serviceImg = new Image();
                  serviceImg.src = this.data.service;
                  serviceImg.setAttribute("crossOrigin", "Anonymous");
                  serviceImg.onload = () => {
                    ctx.drawImage(serviceImg, w0 * 2 + 18, h3, 28, 28);

                    ctx.font = "20px PingFangSC-Regular, PingFang SC";
                    ctx.fillStyle = "white";
                    ctx.textBaseline = "top";
                    ctx.fillText(
                      this.data.serviceTitle,
                      w0 * 2 + 18 + 28 + 4,
                      h4
                    );

                    const shouquanImg = new Image();
                    shouquanImg.src = this.data.shouquan;
                    shouquanImg.setAttribute("crossOrigin", "Anonymous");
                    shouquanImg.onload = () => {
                      ctx.drawImage(shouquanImg, w0 * 3 + 18, h3, 28, 28);

                      ctx.font = "20px PingFangSC-Regular, PingFang SC";
                      ctx.fillStyle = "white";
                      ctx.textBaseline = "top";
                      ctx.fillText(
                        this.data.shouquanTitle,
                        w0 * 3 + 18 + 28 + 4,
                        h4
                      );

                      ctx.save();
                      const that = this;
                      setTimeout(() => {
                        const imgBase64 = canvas.toDataURL("image/jpeg", 1.0);
                        that.posterImg = imgBase64;
                      }, 300);
                    };
                  };
                };
              };
              // };
            };
          };
        };
      }
    },
    closePoster() {
      this.$emit("closePoster");
    },
    openShare() {
      this.$emit("openShare");
    }
  }
};
</script>

<style lang="less" scoped>
.poster {
  ::v-deep .van-dialog {
    top: 50%;
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0);
  }

  .canvas_back {
    position: fixed;
    top: -10000px;
    left: -10000px;
  }

  .canvas {
    display: block;
  }

  .posterImg {
    width: 100%;
    display: block;
  }

  .actions {
    margin-top: 10px;
    display: flex;
    flex-direction: row;

    img {
      width: 40px;
      height: 40px;
    }

    .actions_item {
      flex: 1;
      color: rgba(255, 255, 255, 0.5);
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
  }
}
</style>
